import { render } from "./TrackingOrder.vue?vue&type=template&id=b6a006d0&scoped=true"
import script from "./TrackingOrder.vue?vue&type=script&lang=js"
export * from "./TrackingOrder.vue?vue&type=script&lang=js"

import "./TrackingOrder.vue?vue&type=style&index=0&id=b6a006d0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6a006d0"]])

export default __exports__